module.exports = __webpack_public_path__ + "img/undraw_education_f8ru.cbc1e760.svg";